import React from 'react';
import { string } from 'prop-types';
import { ParallaxBanner, ParallaxContext } from 'react-scroll-parallax';

export class HeroBanner extends React.Component {
  static contextType = ParallaxContext;

  componentDidMount() {
    this.handleLoad();
  }

  handleLoad = () => {
    const parallaxController = this.context;
    window.requestAnimationFrame(() => {
      parallaxController.update();
    });
  };

  render() {
    const { src, ...props } = this.props;

    return (
      <ParallaxBanner
        layers={[
          {
            image: src,
            amount: 0.25,
          },
        ]}
        {...props}
      />
    );
  }
}

HeroBanner.propTypes = {
  src: string.isRequired,
};

export default HeroBanner;
